import { render, staticRenderFns } from "./SpoiledLogo.vue?vue&type=template&id=30f4c45c&scoped=true&"
import script from "./SpoiledLogo.vue?vue&type=script&lang=js&"
export * from "./SpoiledLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f4c45c",
  null
  
)

export default component.exports